<template>
    <div class="hero-sass hero-swiper-btn" id="home">
        <div class="container_f1">
            <div class="swiper-wrapper">
                <swiper :options="swiperOption">

                    <div class="swiper-slide" :style="bgImg">
                        <div class="hero-item text-center">
                            <div class="hero-content">
                                <h2 class="h1 hero-content-title font-weight-light">Built for Engineering teams</h2>
                                <h6 class="hero-content-subtitle">Hedwig provides an in-depth insight and uses objective data to communicate amongst your engineering team</h6>
                                <div onclick="location.href='https://app.gohedwig.in/auth'" class="btn btn--green">
                                    <span class="btn-icon  ml-0 mr-2"></span> Try it now
                                </div>
                            </div>
                            <div class="hero-thumb">
                                <img src="../assets/img/hero/heroimage.png" class="img-fluid" alt="hero thumb">
                            </div>
                        </div>
                    </div>
                    <!-- Optional controls -->
                </swiper>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            bgImg: {
                backgroundImage: `url(${require("../assets/img/hero/hero-sass/hero-sass-bg.jpg")})`
            },
            swiperOption: {
                speed: 1500,
                loop: true,
                effect: 'fade',
                autoplay: false,
                spaceBetween : 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            }
        };
    }
};
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variabls.scss';
    @import '../assets/scss/elements/hero-sass.scss'
</style>
